import type { User } from 'oidc-client-ts';

import { OIDC_RETURN_URL_KEY } from '@/hooks/use-login';
import { userManager } from '@/user-manager';

export const useAuthProvider = () => {
  const onSigninCallback = (_user: User | undefined) => {
    const url = new URL(window.location.href);
    const search = url.searchParams;

    search.delete('state');
    search.delete('session_state');
    search.delete('iss');
    search.delete('code');

    const returnPath = sessionStorage.getItem(OIDC_RETURN_URL_KEY);
    if (returnPath) {
      sessionStorage.removeItem(OIDC_RETURN_URL_KEY);
      window.location.replace(`${window.location.origin}${returnPath}`);
      return;
    }

    window.history.replaceState(
      {},
      document.title,
      `${window.location.pathname}${search.toString() ? `?${search.toString()}` : ''}`,
    );
  };

  return { onSigninCallback, userManager };
};
